<script lang="ts">
  import { Button } from '@bond/components'
  import type { PageData } from './$types'
  import { DISCOVER_STRINGS } from '../strings'
  import StudioCard from '$lib/components/StudioCard.svelte'
  import BruceInformation from '$lib/components/BruceInformation.svelte'
  import { utils } from '$lib/utils'

  export let data: PageData

  $: ({
    lang,
    city,
    vicinity,
    studios,
    imageUrl,
    categoriesInVicinity,
    title,
    description,
  } = data)

  $: localeRoute = utils.getRoute(lang)
</script>

<div class="container">
  <h1>{title}</h1>
  <p>{description}</p>
  <Button href={localeRoute(`/studios/${city.speakingUrl}`)} rounded>
    {DISCOVER_STRINGS[lang].EXPLORE_ALL_STUDIOS}
  </Button>
  {#if studios.length > 0}
    <ul class="studio-grid">
      {#each studios as studio (studio.id)}
        <li>
          <StudioCard {imageUrl} {studio} vicinity rating description />
        </li>
      {/each}
    </ul>
  {:else}
    <p>{DISCOVER_STRINGS[lang].NO_STUDIOS_FOUND}</p>
  {/if}
  <BruceInformation title={false} description={false} center />
  <section>
    <h2>{DISCOVER_STRINGS[lang].OTHER_CATEGORIES} {vicinity}</h2>
    <ul class="categories">
      {#each categoriesInVicinity as category, index (index)}
        <li>
          <Button
            href={localeRoute(
              `/discover/${city.speakingUrl}/${utils.toSpeakingUrl(
                vicinity,
              )}/${utils.toSpeakingUrl(category)}`,
            )}
            rounded
            variant="outlined"
          >
            {category}
          </Button>
        </li>
      {/each}
    </ul>
  </section>
</div>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2em;

    @media screen and (max-width: breakpoints.$breakpoint-md) {
      width: calc(100% - 32px);
    }

    h1 {
      text-align: center;
      margin: 1em 0 0 0;
    }

    p {
      margin: 0;
      text-align: center;
      max-width: 600px;
    }

    .studio-grid {
      display: grid;
      list-style-type: none;
      margin: 0;
      padding: 0;
      grid-template-columns: repeat(8, minmax(0, 1fr));
      gap: 1em;
      width: 100%;
      max-width: var(--page-max-width);

      & > * {
        grid-column: span 2;

        &:first-child:nth-last-child(1) {
          grid-column: 4 / 6;
        }

        &:first-child:nth-last-child(2) ~ * {
          grid-column: 5 / 7;
        }

        &:first-child:nth-last-child(2) {
          grid-column: 3 / 5;
        }

        &:first-child:nth-last-child(3) ~ :nth-last-child(1) {
          grid-column: 6 / 8;
        }

        &:first-child:nth-last-child(3) ~ :nth-last-child(2) {
          grid-column: 4 / 6;
        }

        &:first-child:nth-last-child(3) {
          grid-column: 2 / 4;
        }
      }

      @media screen and (max-width: breakpoints.$breakpoint-md) {
        grid-template-columns: repeat(4, minmax(0, 1fr));
      }

      @media screen and (max-width: breakpoints.$breakpoint-sm) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }

    h2 {
      text-align: center;
    }

    .categories {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1em;
      list-style-type: none;
      padding: 0;
      margin: 0;
      width: 100%;
      max-width: var(--page-max-width);
    }
  }
</style>
